// utils.ts or utils.tsx (if you're using React components)
export class Utils {
    static isDataURL(s: string): boolean {
        const regex = /^data:([a-zA-Z0-9]+\/[a-zA-Z0-9-.+]+).*(;base64)?,/;
        return !!s.match(regex);
    }
    // Add more static utility methods as needed
}
